var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("van-nav-bar", { attrs: { title: "用户信息" } }),
      _c(
        "van-form",
        { on: { submit: _vm.onSubmit } },
        [
          _c("van-field", {
            attrs: {
              name: "登录账号",
              label: "登录账号",
              disabled: "",
              placeholder: "登录账号",
            },
            model: {
              value: _vm.userInfo.userName,
              callback: function ($$v) {
                _vm.$set(_vm.userInfo, "userName", $$v)
              },
              expression: "userInfo.userName",
            },
          }),
          _c("van-field", {
            attrs: {
              name: "用户昵称",
              label: "用户昵称",
              disabled: "",
              placeholder: "用户昵称",
            },
            model: {
              value: _vm.userInfo.nickName,
              callback: function ($$v) {
                _vm.$set(_vm.userInfo, "nickName", $$v)
              },
              expression: "userInfo.nickName",
            },
          }),
          _c("van-field", {
            attrs: {
              name: "手机号码",
              label: "手机号码",
              disabled: "",
              placeholder: "手机号码",
            },
            model: {
              value: _vm.userInfo.phonenumber,
              callback: function ($$v) {
                _vm.$set(_vm.userInfo, "phonenumber", $$v)
              },
              expression: "userInfo.phonenumber",
            },
          }),
          _c("van-field", {
            attrs: {
              name: "公司/部门",
              label: "公司/部门",
              disabled: "",
              placeholder: "公司/部门",
              type: "textarea",
            },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function () {
                  return _vm._l(_vm.userInfo.deptNames, function (item) {
                    return _c("div", [_vm._v(_vm._s(item))])
                  })
                },
                proxy: true,
              },
            ]),
          }),
          _c(
            "div",
            { staticStyle: { margin: "16px" } },
            [
              _c(
                "van-button",
                {
                  attrs: {
                    round: "",
                    block: "",
                    type: "warning",
                    "native-type": "submit",
                  },
                  on: { click: _vm.resetPwd },
                },
                [_vm._v("重置密码")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }